module.exports = __webpack_public_path__ + "static/IMG_2507-40c7524ec3a8719583d561248e9dd2ac.jpg";